import React from 'react';
import Tooltip from './Tooltip';
import { Placement } from '@floating-ui/dom';

interface INavItemProps {
    label: string;
    selected: boolean;
    tooltip: string;
    badge?: number;
    disabled?: boolean;
    tooltipCSS?: string;
    placement?: Placement;
    onClick: () => void;
}

const style = {
    badge: "hs-tab-active:bg-blue-100 hs-tab-active:text-blue-600 dark:hs-tab-active:bg-blue-800 dark:hs-tab-active:text-white ms-1 py-0.5 px-1.5 rounded-full text-xs font-bold bg-red-600 text-white dark:bg-neutral-700 dark:text-neutral-300",
    tab: "hs-tab-active:font-semibold hs-tab-active:border-blue-600 hs-tab-active:text-blue-600 py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-blue-600 focus:outline-hidden focus:text-blue-600 disabled:opacity-50 disabled:pointer-events-none dark:text-neutral-400 dark:hover:text-blue-500",
    tab2: "Tabitematom h-7 flex justify-start items-center overflow-hidden"
}

const NavItem = (props: INavItemProps) => {
    const { badge, disabled, label, selected, tooltip, tooltipCSS, placement, onClick } = props;

    const tips = tooltip.split('|');
    const css = tooltipCSS ? tooltipCSS.split('|') : null;

    return (
        <Tooltip 
            className={`px-2 border-b-4 outline-b-4 ${selected ? 'border-border-strong' : 'border-border-default'} ${disabled ? 'cursor-not-allowed' : '' }`}
            textStyling={`z-10 max-w-[250px] ${css ? (disabled ? css[1] : css[0]) : '' }`}
            text={disabled && tips.length > 1 ? tips[1] : tips[0]}
            placement={placement}
        >
            <div className={`flex justify-center items-end ${selected ? '' : ''}`}>
                <div className={`h-7 flex justify-start items-center overflow-hidden`}>
                    <div className="h-5 flex justify-start items-center">
                        <button
                            onClick={onClick}
                            disabled={disabled}
                            className={`justify-start text-text-lighter text-base font-normal font-['Inter'] leading-snug ${disabled ? 'cursor-not-allowed' : 'clickable' }`}
                        >
                            {label}
                        </button>
                        {badge !== undefined && <span className={style.badge}>{badge}</span>}
                    </div>
                </div>
            </div>
        </Tooltip>
    );
};

export default NavItem;


